import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../utils/cn.js';
/**
 * Placeholder loader — the default loading state in Clari, in preference to
 * spinners (CHARTE §10.7: spinners reserved for paiement critique).
 */
export function Skeleton({ width = '100%', height = 16, shape = 'rounded', className, style, ...rest }) {
    const mergedStyle = {
        width,
        height,
        ...style,
    };
    return (_jsx("span", { role: "status", "aria-busy": "true", "aria-live": "polite", className: cn('clari-skeleton', shape === 'rounded' && 'clari-skeleton--rounded', shape === 'circle' && 'clari-skeleton--circle', className), style: mergedStyle, ...rest }));
}
//# sourceMappingURL=Skeleton.js.map